import $ from 'jquery';

const key = 'has_seen_popup_';

export default class DistrictAlert {
  constructor(element) {
    this.$element = $(element);
    this.$instance = this.getAlert();
    this.click = this.click.bind(this);
    if (this.$instance.length && this.areWeThere) {
      this.storageKey = this.createKey();
      if (!this.getVariable()) {
        this.listen();
        this.show();
      }
    }
  }

  getAlert() {
    return this.$element.find('.node');
  }

  createKey() {
    const id = this.$instance.attr('id');
    return key + /(\d+)/.exec(id)[0];
  }

  getVariable() {
    return sessionStorage.getItem(this.storageKey) || false;
  }

  setVariable() {
    sessionStorage.setItem(this.storageKey, true);
  }

  click(event) {
    this.setVariable();
    event.stopPropagation();

    if ($(event.target).is('.block, .node-links')) {
      event.preventDefault();
      this.hide();
    }
  }

  hide() {
    this.$element.removeClass('show');
  }

  show() {
    this.$element.addClass('show');
  }

  listen() {
    this.$element.on('click', this.click);
  }

  get areWeThere() {
    const url = this.$element.find('.link-read-more a').attr('href');
    const currentURL = document.location.pathname;
    return url !== currentURL;
  }
}



// WEBPACK FOOTER //
// ./PopupAlert.js